export const JEWELLERY_PRODUCTS = [
  {
    id: 'j1',
    name: 'Rose Gold Pendant Necklace',
    price: 1299,
    oldPrice: 1899,
    badge: 'New',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400&h=400&fit=crop',
  },
  {
    id: 'j2',
    name: 'Pearl Drop Earrings',
    price: 899,
    oldPrice: 1299,
    badge: '-30%',
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400&h=400&fit=crop',
  },
  {
    id: 'j3',
    name: 'Charm Bracelet - Blush',
    price: 749,
    oldPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=400&fit=crop',
  },
  {
    id: 'j4',
    name: 'Layered Chain Necklace',
    price: 1599,
    oldPrice: 2199,
    badge: 'Bestseller',
    image: 'https://images.unsplash.com/photo-1515562141589-67f0d93e2881?w=400&h=400&fit=crop',
  },
];

export const BAGS_PRODUCTS = [
  {
    id: 'b1',
    name: 'Blush Pink Tote Bag',
    price: 2499,
    oldPrice: 3299,
    badge: 'New',
    image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=400&h=400&fit=crop',
  },
  {
    id: 'b2',
    name: 'Sage Green Clutch',
    price: 1199,
    oldPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&h=400&fit=crop',
  },
  {
    id: 'b3',
    name: 'Crossbody Sling - Rose',
    price: 1799,
    oldPrice: 2249,
    badge: '-20%',
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&h=400&fit=crop',
  },
  {
    id: 'b4',
    name: 'Mini Bucket Bag - Pearl',
    price: 1999,
    oldPrice: 2599,
    badge: 'Bestseller',
    image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400&h=400&fit=crop',
  },
];
